import TypeDefautActions from '../../../../actions/type-defaut.actions';

import assign from 'lodash/assign';
import _ from 'lodash';

require('./type-defaut.scss');

export default class TypeDefautComponent {
  constructor() {
    this.controller = TypeDefautController;
    this.template = require('./type-defaut.html');
    this.bindings = {
      typeDefaut: '<',
      parentForm: '<',
      onTypeDefautChange: '&'
    };
  }
}

// @ngInject
class TypeDefautController {
  constructor($scope, $ngRedux) {
    this.$scope = $scope;
    this.$ngRedux = $ngRedux;

    this.data = {};
    this.typesDefaut = {};
  }

  $onInit() {
    this.$ngRedux.dispatch(TypeDefautActions.loadData());
    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          typesDefaut: state.typeDefaut,
        };
      }
    )((selectedState) => {
      assign(this, selectedState);
      this.validateTypeDefaut();
    });

    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }

  validateTypeDefaut() {
    if (!this.typeDefaut || this.typesDefaut.fetching || !this.typesDefaut.data) {
      return;
    }

    this.data.typeDefaut = this.typeDefaut.id;
  }

  onChange(value) {
    this.onTypeDefautChange({typeDefaut: _.find(this.typesDefaut.data, {'id': value})});
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/type-defaut/type-defaut.component.js